import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { PurchaseCommissionService } from '@core/services/entities/purchase-commission.service';
import { ListPurchaseCommissionRequestDto } from '@domain/purchase-commission/dtos/list-purchase-commission.request.dto';
import { PurchaseCommissionResponseDto } from '@domain/purchase-commission/dtos/purchase-commission.response.dto';
import { PurchaseCommissionRepository } from './purchase-commission.repository';

@Injectable({
  providedIn: 'root',
})
export class PurchaseCommissionRepositoryService
  implements PurchaseCommissionRepository
{
  constructor(private purchaseCommissionService: PurchaseCommissionService) {}

  list(
    request: ListPurchaseCommissionRequestDto,
  ): Observable<ApiResponse<PageableResponse<PurchaseCommissionResponseDto>>> {
    return this.purchaseCommissionService.list(request);
  }

  show(request: RefId): Observable<ApiResponse<PurchaseCommissionResponseDto>> {
    return this.purchaseCommissionService.show(request);
  }
}
